import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2, FileText } from "lucide-react";
import SectionHeading from "@/components/site/SectionHeading";
import CatalogSearch from "@/components/site/CatalogSearch";
import { PRODUCT_LINES, WHATSAPP_URL } from "@/lib/site";

export default function Produtos() {
  return (
    <>
      <section className="bg-white border-b border-surface-line">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-24">
          <div className="text-xs font-bold uppercase tracking-[0.22em] text-bronze">Produtos & soluções</div>
          <h1 className="mt-4 max-w-4xl font-display text-4xl font-black leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-6xl">
            Encontre a linha certa para sua <span className="text-brand">operação crítica</span>.
          </h1>
          <CatalogSearch />
        </div>
      </section>

      <section className="bg-surface-alt py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <SectionHeading eyebrow="Portfólio" title="Soluções organizadas por aplicação." subtitle="Imagens reais do portfólio representativo. A configuração final é validada de acordo com a sua especificação." />
          <div className="mt-12 grid gap-6 md:grid-cols-2">
            {PRODUCT_LINES.map((line) => (
              <article key={line.slug} className="group overflow-hidden rounded-lg border border-surface-line bg-white shadow-sm transition hover:-translate-y-1 hover:shadow-xl">
                <div className="grid sm:grid-cols-5">
                  <div className="flex min-h-64 items-center justify-center bg-[#eef1f2] p-6 sm:col-span-2">
                    <img src={line.image} alt={line.title} className="max-h-64 w-full object-contain transition-transform duration-500 group-hover:scale-105" loading="lazy" />
                  </div>
                  <div className="p-7 sm:col-span-3">
                    <div className="text-xs font-bold uppercase tracking-[0.2em] text-bronze">Linha técnica</div>
                    <h2 className="mt-3 font-display text-2xl font-bold text-ink">{line.title}</h2>
                    <p className="mt-3 text-sm leading-relaxed text-ink-muted">{line.short}</p>
                    <ul className="mt-5 space-y-2">
                      {line.bullets.map((item) => <li key={item} className="flex gap-2 text-sm text-ink"><CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-brand" />{item}</li>)}
                    </ul>
                    <a href={WHATSAPP_URL(`Olá! Gostaria de cotar a linha ${line.title}.`)} target="_blank" rel="noopener noreferrer" className="mt-6 inline-flex items-center gap-2 font-semibold text-brand hover:text-brand-mid">
                      Cotar esta linha <ArrowRight className="h-4 w-4" />
                    </a>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="border-y border-surface-line bg-white py-16">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <h2 className="font-display text-3xl font-bold text-ink">Prefere consultar nossos catálogos completos?</h2>
          <p className="mx-auto mt-3 max-w-2xl text-ink-muted">Baixe o material técnico e envie as páginas ou referências desejadas ao nosso time.</p>
          <Link to="/catalogos" className="mt-7 inline-flex items-center gap-2 rounded-full bg-brand px-7 py-4 font-semibold text-white hover:bg-brand-mid">
            Ver catálogos completos <FileText className="h-4 w-4" />
          </Link>
        </div>
      </section>

      <section className="bg-brand-noise py-20 text-white">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <h2 className="font-display text-3xl font-bold sm:text-4xl">Não encontrou o item?</h2>
          <p className="mx-auto mt-4 max-w-2xl text-white/80">Atendemos demandas fora do portfólio ativo e buscamos alternativas compatíveis com sua aplicação.</p>
          <a href={WHATSAPP_URL("Olá! Preciso de ajuda para localizar um item fora do catálogo Wellpec.")} target="_blank" rel="noopener noreferrer" className="mt-8 inline-flex items-center gap-2 rounded-full bg-white px-7 py-4 font-semibold text-brand">
            Enviar minha demanda <ArrowRight className="h-4 w-4" />
          </a>
        </div>
      </section>
    </>
  );
}
